import { getFromApiFunction } from "../apiFunctions";

const getProject = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/projects/";
  return getFromApiFunction(endPoint, params);
};

export { getProject };
